import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { OrganizationSettingsService } from "../../services/organizationSettingsService";
import logger from "../../core/utils/logger";

// Async thunk for getting organization settings
export const getOrganizationSettings = createAsyncThunk(
    'organizationSettings/getSettings',
    async (_, { rejectWithValue }) => {
        try {
            console.log("🔄 Fetching organization settings...");
            const response = await OrganizationSettingsService.getOrganizationSettings();
            console.log("✅ Get organization settings response:", response);
            console.log("📋 CustomWorkerOrder:", response?.customWorkerOrder);
            logger.log("Get organization settings response:", response);
            return response;
        } catch (error) {
            console.error("❌ Error fetching organization settings:", error);
            return rejectWithValue(error.response?.data || 'Error getting organization settings');
        }
    }
);

// Async thunk for saving organization settings
export const saveOrganizationSettings = createAsyncThunk(
    'organizationSettings/saveSettings',
    async (settings, { rejectWithValue }) => {
        try {
            console.log("💾 Saving organization settings:", settings);
            const response = await OrganizationSettingsService.saveOrganizationSettings(settings);
            console.log("✅ Save organization settings response:", response);
            logger.log("Save organization settings response:", response);
            return response;
        } catch (error) {
            console.error("❌ Error saving organization settings:", error);
            return rejectWithValue(error.response?.data || 'Error saving organization settings');
        }
    }
);

const initialState = {
    loading: false,
    error: null,
    settings: {
        workerSortBy: 'Name',
        workerSortOrder: 'Asc',
        customWorkerOrder: null,
        notifyAdminOwnChanges: false
    }
};

const organizationSettingsSlice = createSlice({
    name: 'organizationSettings',
    initialState,
    reducers: {
        // Synchronous action to update settings locally (for immediate UI feedback)
        updateOrganizationSettingsLocally: (state, action) => {
            state.settings = { ...state.settings, ...action.payload };
        },
        clearOrganizationSettings: (state) => {
            state.settings = initialState.settings;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        // Get organization settings
        builder.addCase(getOrganizationSettings.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getOrganizationSettings.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.settings = action.payload;
            console.log("📦 Organization settings stored in Redux:", state.settings);
        });
        builder.addCase(getOrganizationSettings.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Save organization settings
        builder.addCase(saveOrganizationSettings.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(saveOrganizationSettings.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.settings = action.payload;
        });
        builder.addCase(saveOrganizationSettings.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    }
});

export const { updateOrganizationSettingsLocally, clearOrganizationSettings } = organizationSettingsSlice.actions;
export default organizationSettingsSlice.reducer;
